import ChevronRightOutlinedIcon from '@mui/icons-material/ChevronRightOutlined';
import SaveOutlinedIcon from '@mui/icons-material/SaveOutlined';
import { Box, Typography } from '@mui/material';

export function DreFormBbarInfo() {
    return (
        <Box
            sx={{
                display: 'flex',
                alignItems: 'center',
                gap: 2,
            }}
        >
            <SaveOutlinedIcon color="primary" />

            <Typography sx={{ maxWidth: { xs: 'auto', md: 190 }, lineHeight: 1.2 }}>SALVE SEU PREENCHIMENTO A QUALQUER MOMENTO</Typography>

            <ChevronRightOutlinedIcon color="primary" />
        </Box>
    );
}
